import type { B2bAdminStatus } from '@Common/types/bo/b2b/admins';

/**
 * Invitation resend is available for invited correspondents even if email_verified is true
 * (they may have started first connection without completing onboarding).
 */
export function canResendB2bAdminInvitation({
  status,
  email_verified,
}: {
  status: B2bAdminStatus;
  email_verified: boolean;
}): boolean {
  if (status === 'inactive') {
    return false;
  }

  if (status === 'invited') {
    return true;
  }

  return !email_verified;
}
